import { GIT_PROVIDER } from '@/config'
import type { TableDataType } from '@/types'
import {
  buildBitbucketCompareUrl,
  buildBitbucketPolicyRepoUrl,
  buildBitbucketRepoUrl,
  buildBitbucketRuleRepoUrl,
  buildBitbucketUserFunctionRepoUrl,
} from './bitbucket'
import {
  buildGithubCompareUrl,
  buildGithubPolicyRepoUrl,
  buildGithubRepoUrl,
  buildGithubRuleRepoUrl,
  buildGithubUserFunctionRepoUrl,
} from './github'

const GITHUB_PROVIDER_ENABLED = GIT_PROVIDER === 'github'

export function buildRuleRepoUrl(name?: string): string {
  return GITHUB_PROVIDER_ENABLED ? buildGithubRuleRepoUrl(name) : buildBitbucketRuleRepoUrl(name)
}

export function buildPolicyRepoUrl(name?: string): string {
  return GITHUB_PROVIDER_ENABLED ? buildGithubPolicyRepoUrl(name) : buildBitbucketPolicyRepoUrl(name)
}

export function buildUserFunctionRepoUrl(name?: string): string {
  return GITHUB_PROVIDER_ENABLED ? buildGithubUserFunctionRepoUrl(name) : buildBitbucketUserFunctionRepoUrl(name)
}

export function buildRepoUrl(type: TableDataType, name: string): string | undefined {
  return GITHUB_PROVIDER_ENABLED ? buildGithubRepoUrl(type, name) : buildBitbucketRepoUrl(type, name)
}

export function buildCompareUrl(type: TableDataType, name: string, source: string, target: string): string {
  return GITHUB_PROVIDER_ENABLED
    ? buildGithubCompareUrl(type, name, source, target)
    : buildBitbucketCompareUrl(type, name, `refs/heads/${source}`, target)
}
